<ng-select
  *ngIf="!isListMode; else listModeTemplate"
  #ngSelect
  appendTo="body"
  class="selector-with-pagination"
  [ngClass]="classList"
  (change)="onChange($event)"
  (open)="onOpen($event)"
  (clear)="onClear($event)"
  [placeholder]="placeholder"
  [items]="items"
  [multiple]="multiple"
  [closeOnSelect]="closeOnSelect"
  [searchable]="true"
  [loading]="loading"
  [(ngModel)]="value"
  [minTermLength]="0"
  [disabled]="isDisabled"
  [compareWith]="compareFn"
  [typeahead]="quickSearchTermInput$"
  loadingText="{{ 'CA::Loading' | abpLocalization }}..."
  bindLabel="name">
  <ng-template *ngIf="headerInfo" ng-header-tmp>
    <div [ngStyle]="headerInfoStyle" [innerHtml]="headerInfo"></div>
  </ng-template>
  <ng-template ng-footer-tmp>
    <div class="w-100 d-flex d-flex flex-row justify-content-start align-items-center">
      <mat-paginator
        class="d-flex flex-row justify-content-row"
        style="flex: 0 0 350px"
        [length]="totalCount"
        [pageSize]="itemsPerPage"
        [pageIndex]="pageIndex"
        [hidePageSize]="true"
        [showFirstLastButtons]="true"
        (page)="onPageChange($event)"></mat-paginator>
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <div class="query-selection-panel-query-name">
      <div class="truncate-text" [ngbTooltip]="item.name" showTooltipIfTruncated container="body">
        {{ item.name }}
      </div>
      <div class="query-selection-panel-info-button">
        <div
          [ngStyle]="{
            color: !item.lastQueryVersionIndexed ? 'rgb(255, 157, 9)' : 'rgb(0, 0, 0)',
          }"
          style="vertical-align: top"
          #popover="ngbPopover"
          [ngbPopover]="previewQueryPopContent"
          [popoverTitle]="previewQueryPopTitle"
          popoverClass="query-preview-popover"
          placement="right auto"
          triggers="manual"
          container="body"
          [autoClose]="'outside'"
          (click)="toggleQueryPreviewPopover(popover, item, $event)">
          <div *ngIf="isQueryPreviewLoading && item.id === previewQueryId; else loaded">
            <i class="fas fa-circle-notch fa-spin"></i>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-select>

<ng-template
  #previewQueryPopContent
  let-queryItems="queryItems"
  let-categories="categories"
  let-query="query">
  <ca-query-detail-builder
    #builder
    [isReadonly]="true"
    (abpInit)="builder.loadQueryItems(queryItems, categories, query)"></ca-query-detail-builder>
</ng-template>

<ng-template #previewQueryPopTitle let-query="query">
  <div
    *ngIf="query.isCategory"
    class="badge category-badge ps-1"
    [ngStyle]="colorUtils.getColors(query.categoryColor)"
    [title]="query.categoryName">
    {{ query.categoryName }}
  </div>
  <div *ngIf="isListMode && query.indexingStartDate" class="text-muted small mt-1">
    {{ 'Category::IndexingPeriod' | abpLocalization }}:
    {{ query.indexingStartDate | caDatePipe: dateDisplayType.Date : true }} –
    <ng-container *ngIf="query.indexingEndDate">
      {{ query.indexingEndDate | caDatePipe: dateDisplayType.Date : true }}
    </ng-container>
  </div>
</ng-template>

<ng-template #listModeTemplate>
  <div class="border p-2">
    <div class="position-relative mb-2">
      <i
        class="fas fa-search position-absolute top-50 start-0 translate-middle-y ms-2 text-muted"></i>
      <input
        type="text"
        class="form-control form-control-sm ps-4"
        [placeholder]="searchPlaceholder | abpLocalization"
        [disabled]="isDisabled"
        (input)="onListSearchInput($event)" />
    </div>
    <div class="user-defined-category-list overflow-auto border-top">
      <div *ngIf="loading" class="text-center text-muted py-3">
        <i class="fas fa-circle-notch fa-spin me-1"></i>
        {{ 'CA::Loading' | abpLocalization }}...
      </div>
      <div *ngIf="isListEmpty" class="text-center text-muted fst-italic py-3">
        {{ 'AbpUi::NoResults' | abpLocalization }}
      </div>
      <div
        *ngIf="isSelectAllVisible"
        class="form-check d-flex align-items-center gap-2 m-0 px-1 py-2 border-bottom fw-semibold">
        <input
          type="checkbox"
          class="form-check-input flex-shrink-0 m-0"
          [id]="selectAllCheckboxId"
          [checked]="isAllVisibleSelected"
          [indeterminate]="isSomeVisibleSelected"
          [disabled]="isDisabled"
          (change)="onSelectAllChange($event)" />
        <label class="form-check-label flex-grow-1" [for]="selectAllCheckboxId">
          {{ 'AbpUi::SelectAll' | abpLocalization }} ({{ visibleSelectableCount }})
        </label>
      </div>
      <ng-container *ngIf="!loading">
        <div
          *ngFor="let item of items; trackBy: trackById"
          class="form-check d-flex align-items-center gap-2 mb-2 mt-2 px-1 py-1">
          <input
            type="checkbox"
            class="form-check-input flex-shrink-0 m-0"
            [id]="getListItemCheckboxId(item)"
            [checked]="isItemSelected(item)"
            [disabled]="isListItemDisabled(item)"
            (change)="onListItemChange(item, $event)" />
          <label
            class="form-check-label flex-grow-1 overflow-hidden"
            [for]="getListItemCheckboxId(item)">
            <div
              class="truncate-text"
              [ngbTooltip]="item.name"
              showTooltipIfTruncated
              container="body">
              {{ item.name }}
            </div>
          </label>
          <button
            type="button"
            class="btn btn-link btn-sm flex-shrink-0 p-0 px-1 border-0 lh-1"
            [ngStyle]="getQueryInfoIconStyle(item)"
            #listPopover="ngbPopover"
            [ngbPopover]="previewQueryPopContent"
            [popoverTitle]="previewQueryPopTitle"
            popoverClass="query-preview-popover query-preview-popover-list"
            placement="right auto"
            triggers="manual"
            container="body"
            [autoClose]="'outside'"
            (click)="toggleQueryPreviewPopover(listPopover, item, $event)">
            <i
              *ngIf="isQueryPreviewLoadingFor(item); else loaded"
              class="fas fa-circle-notch fa-spin"></i>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #loaded>
  <i class="fa-sharp fa-light fa-circle-info"></i>
</ng-template>
